export default {
    'odkryj_dostep':'Découvrez toutes les catégories et profitez d\'un accès complet.',
			'odkryj_dostep_opis':  'Un seul joueur paie et déverrouille le jeu pour les deux !',
            'kontynuuj_gre':  'Continue de jouer',
            'zacznij_od_nowa':  'Recommencer',
            'dolacz_do_gry':  'Rejoindre le jeu',
            'prosze_czekac':  'S\'il vous plaît, attendez',
            'zamknij':  '<i class="fa fa-times"></i> Fermer',
            'start_gry':  "Début du jeu",
			'graj':  'Jouer',
			'wpisz_imiona_graczy':'Entrez les noms des joueurs',
			'twoje_imie':'Votre nom',
			'imie_drugiego_gracza':'nom du deuxième joueur',
			'wyslij_zaproszenie':  'Envoyer l\'invitation <i class="fas fa-chevron-right"></i>',
			'konfiguracja_polaczenia':  'Configuration de la connexion',
			'daj_drugiemu':  "Dites à l'autre joueur de scanner le code ci-dessous",
			'wpisz_imiona':  'Entrez les noms des deux joueurs',
			'wpisz_rozne_imiona':  'Entrez des noms différents les uns des autres',
			'odblokowane':  'Tous les niveaux ont été déverrouillés. Continuez à jouer !',
			'poziomy':  'Catégories',
			'rozpocznij_gre':  'Démarrer le jeu <i class="fas fa-chevron-right"></i>',
			'poziom1':  'Niveau 1',
			'poziom2':  'Niveau 2',
			'poziom3':  'Niveau 3',
			'oczekuje_na_druga_osobe':  'En attente de la réponse de l\'autre personne',
			'oczekuje_na_druga_osobe_2':  "En attendant l'autre personne",
			'graj_dalej':  'Continue à jouer <i class="fas fa-chevron-right"></i>',
			'dokoncz_gre':  'Terminer le jeu <i class="fas fa-chevron-right"></i>',
			'odpowiadaj_na_pytania':  'Répondez aux questions',
			'pytanie':  'Question',
			'z':'Avec',
			'oczekuje_na_osobe':  'En attente de la réponse de l\'autre personne',
			'wyniki_rozgrywki':  "Résultats du jeu",
			'gratulacje':  "Toutes nos félicitations",
			'macie_zgodnosc':  "Vous êtes compatibles",
			'znasz_grugiego_gracza':  "Vous connaissez l'autre joueur sur",
			'zna_ciebie':  "vous connaît",
			'jak_odpowiadaliscie':  '<i class="fas fa-tasks"></i> Voyez comment vous avez répondu',
			'pochwal_sie':  '<i class="fas fa-share-alt"></i> Montrez votre score',
			'wasze_odpowiedzi':  "vos réponses",
			'skanuj_kod':"Scanner le code",
			'statystyka':  "Statistiques",
			'statystyka_gry':  "Statistiques du jeu",
			'powiadom':  '<i class="fas fa-envelope" style="right:auto; left: 15px"></i> Notifier la nouvelle version',
			'zapisalismy_cie':  'Nous avons enregistré votre adresse e-mail',
			'rozpocznij':  'Démarrer <i class="fas fa-chevron-right"></i>',
			'poznajcie_sie':  "Apprendre à se connaître l'un l'autre",
			'jak_znasz':  "Matching Halves est un jeu pour couples qui testera à quel point vous connaissez votre partenaire et à quel point il vous connaît.",
			'help1':  "Vous avez déjà commencé le jeu. Si vous voulez continuer, appuyez sur le bouton ci-dessous.",
			'help2':  "Cependant, vous souhaitez recommencer le jeu ou avec un nouveau joueur - appuyez sur le bouton ci-dessous.",
			'help3':  "Soyez le premier joueur à configurer le jeu - ajoutez les noms des joueurs et demandez au deuxième joueur de scanner le code généré.",
			'help4':  "Une fois que le premier joueur a généré le code, appuyez sur le bouton ci-dessous et scannez le code.",
			'help5':  "Après avoir entré les noms des joueurs, appuyez sur le bouton \"Envoyer une invitation\" et faites scanner le code généré par l'autre joueur.",
			'help6':  "Dites à l'autre joueur de scanner le code ci-dessous",
			'help7':  "Scannez le code généré par l'autre joueur",
			'kup':  "Acheter",
			'zagraj_ponownie':  '<i class="fas fa-play" style="right:auto; left: 15px"></i> Rejouer',
			'opis_gry':  'Description du jeu',
			'poziom':  'Niveau',
			'ext_desc':  '<br>Matching Halves est un jeu pour couples qui vous permettra de tester à quel point vous connaissez votre partenaire et à quel point il vous connaît.<br><br>Vous jouez en ligne en même temps sur deux appareils. Vous devez tous les deux télécharger le jeu depuis la boutique.<br><br>Une personne démarre le jeu en cliquant sur le bouton "Démarrer le jeu" et entre vos noms.<br><br>L\'autre personne rejoint le jeu en cliquant sur le bouton "Rejoindre la partie" et scanne le code généré par la personne qui lance la partie. Après avoir scanné le code, les deux joueurs verront le début du jeu et les catégories.<br><br>L\'application comporte 6 catégories, chacune avec 3 niveaux de difficulté. Vous commencez par le niveau le plus facile, c\'est-à-dire le niveau 1 (compléter le niveau 1 - vous permet de commencer le suivant).<br><br>Ne vous laissez pas décourager par des questions apparemment simples, car plus vous vous enfoncerez dans la forêt, plus il sera difficile et plus épicé !<br><br>W en même temps, la même question apparaîtra sur vos téléphones ou tablettes, à laquelle vous répondez oui / non ou marquez une réponse spécifique. Votre tâche consiste uniquement à cliquer sur la bonne réponse.<br><br>Vous répondez d\'abord à ce que pense votre partenaire, puis vous répondez par vous-même à ce que vous pensez. Après chaque niveau, vous pouvez vérifier comment vous avez répondu et quel pourcentage vous avez obtenu.<br><br>Vous pouvez arrêter le jeu à tout moment et le terminer plus tard, mais si vous recommencez le jeu, vos réponses précédentes sont supprimées.<br> <br>Amusez-vous ! <br><br><br><br><br>',
			'druga_osoba_odpowiedziala':  'L\'autre personne attend votre réponse',
			'confirm_text_1':  'Voulez-vous recommencer le jeu ?',
			'confirm_text_2':  'Vous perdrez vos réponses précédentes.',
			'yes_button':  '<i class="fa fa-check"></i> Oui, je recommence',
			'no_button':  '<i class="fa fa-times"></i> Non, je joue toujours',
			'back':  '<i class="fas fa-chevron-left"></i> retour',
			'backk':  '<i class="fas fa-chevron-left" style="right:auto;left:15px;"></i> Retour',
			'podsumowanie_wynikow':  'Résumé des résultats<i class="fas fa-chevron-right"></i>',						
			
			'Życie codzienne': 'Vie courante',
			'Daily life': 'Vie courante',
			'La vida cotidiana': 'Vie courante',
			'Vie courante': 'Vie courante',
			'Alltagsleben': 'Vie courante',
			'Vita di ogni giorno': 'Vie courante',
			'Vida cotidiana': 'Vie courante',
			
			'Osobowość / charakter': 'Caractère de la personnalité',
			'Personalità/carattere': 'Caractère de la personnalité',
			'Personality / character': 'Caractère de la personnalité',
			'Caracter personal': 'Caractère de la personnalité',
			'Caractère de la personnalité': 'Caractère de la personnalité',
			'Personalidade / personagem': 'Caractère de la personnalité',
			'Persönlichkeit Charakter': 'Caractère de la personnalité',
			
			'Życie towarzyskie': 'Vie sociale',
			'Social life': 'Vie sociale',
			'Vida social': 'Vie sociale',
			'Vie sociale': 'Vie sociale',
			'Soziales Leben': 'Vie sociale',
			'Vita sociale': 'Vie sociale',
			
			'Wyznawane wartości': 'Valeurs adoptées',
			'Values / beliefs': 'Valeurs adoptées',
			'Valores propugnados': 'Valeurs adoptées',
			'Valeurs adoptées': 'Valeurs adoptées',
			'Valores expostos': 'Valeurs adoptées',
			'Vertraute Werte': 'Valeurs adoptées',
			'Valori sposati': 'Valeurs adoptées',
			
			'Nałogi / nawyki': 'Dépendances / habitudes',
			'Habits / Addictions': 'Dépendances / habitudes',
			'Adicciones / hábitos': 'Dépendances / habitudes',
			'Dépendances / habitudes': 'Dépendances / habitudes',
			'Vícios / hábitos': 'Dépendances / habitudes',
			'Süchte / Gewohnheiten': 'Dépendances / habitudes',
			'Dipendenze/abitudini': 'Dépendances / habitudes',
			
			'Seks':'Sexe',
			'Sex':'Sexe',
			'Sexo':'Sexe',
			'Sexe':'Sexe',
			'Sesso':'Sexe',
			
            'polski': 'Polski',
            'angielski': 'English',
            'hiszpanski': 'Español',
            'wloski': 'Italiano',
            'francuski': 'Français',
			'portugalski': 'Português',
			'niemiecki': 'Deutsch',
			'jasny': 'Clair',
			'ciemny': 'Foncé',
			'blad_polaczenia': "Erreur de connexion. Veuillez réessayer.",
			'przekaz_kod_gry': "Ton code de jeu",
			'przekaz_kod_gry_drugi_gracz': "Tu peux également transmettre le code du jeu pour le deuxième joueur",
"skanuj_kod_aparatem": "Scanne le code avec la caméra",
  "wpisz_kod_recznie": "Saisis le code manuellement",
  "wprowadz_kod": "Saisis le code reçu",
  "wprowadz_kod_gry": "Saisis le code du jeu",
  "help8": "Dans le champ ci-dessous, saisis le code du jeu reçu du deuxième joueur. Une fois saisi, le jeu démarrera automatiquement",
    "nieprawidlowy_kod_gry": "Le code saisi est invalide",
  "powrot_do_kategorii": "Retour aux catégories"



}